import React, { useState } from 'react';
import { Key, AlertTriangle } from 'lucide-react';
import { API } from '../App';

export default function ForcePasswordChange({ token, onComplete }) {
  const [newPw, setNewPw] = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPw.length < 8) { setError('Passwort muss mindestens 8 Zeichen lang sein.'); return; }
    if (newPw !== confirmPw) { setError('Passwörter stimmen nicht überein.'); return; }
    setSaving(true);
    try {
      const r = await fetch(`${API}/api/profile/change-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ new_password: newPw }),
      });
      const d = await r.json();
      if (d.status) { onComplete(); }
      else { setError(d.detail || 'Fehler beim Ändern.'); }
    } catch { setError('Netzwerkfehler.'); }
    setSaving(false);
  };

  return (
    <div className="login-page" data-testid="force-password-change">
      <div className="login-card">
        <div className="login-header">
          <Key size={28} color="#fff" />
          <h2>Passwort ändern</h2>
          <p>Bitte ändern Sie Ihr Initial-Passwort</p>
        </div>
        <div className="login-body">
          <div className="design-info-box" style={{ marginBottom: 16, background: 'rgba(245,158,11,0.08)', borderColor: 'rgba(245,158,11,0.2)', color: '#92400E' }}>
            <AlertTriangle size={14} />
            <div>Aus Sicherheitsgründen müssen Sie beim ersten Login ein neues Passwort vergeben.</div>
          </div>
          {error && <div className="login-error" data-testid="force-pw-error">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Neues Passwort</label>
              <input
                className="form-input"
                type="password"
                value={newPw}
                onChange={e => setNewPw(e.target.value)}
                placeholder="Min. 8 Zeichen"
                data-testid="force-pw-new"
                autoFocus
              />
            </div>
            <div className="form-group">
              <label>Passwort bestätigen</label>
              <input
                className="form-input"
                type="password"
                value={confirmPw}
                onChange={e => setConfirmPw(e.target.value)}
                placeholder="Passwort wiederholen"
                data-testid="force-pw-confirm"
              />
            </div>
            <button className="btn btn-primary" style={{ width: '100%' }} type="submit" disabled={saving} data-testid="force-pw-submit">
              {saving ? 'Speichern...' : 'Passwort ändern'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
